import { render, staticRenderFns } from "./BannerLocalization.vue?vue&type=template&id=8cc0ff7c&scoped=true&"
import script from "./BannerLocalization.vue?vue&type=script&lang=js&"
export * from "./BannerLocalization.vue?vue&type=script&lang=js&"
import style0 from "./BannerLocalization.vue?vue&type=style&index=0&id=8cc0ff7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc0ff7c",
  null
  
)

export default component.exports